export default __webpack_public_path__ + "static/media/default.046f8181066c488d038c0b379cfd22ba.png";